<template>
  <div class="content" v-if="loadFleetData">
    <base-header class="pb-6">
    </base-header>
    <b-container fluid class="mt--6">
      <div>
        <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
          <template slot="header">
            <div>
              <div>
                <h3 class="mb-0">Fleet overview</h3>
                <p class="text-sm mb-0">
                  Organisation asset overview
                </p>
              </div>
            </div>
          </template>
          <div>
            <b-col cols="12" class="d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <div>
                <base-input v-model="searchQuery"
                            prepend-icon="fas fa-search"
                            placeholder="Search...">
                </base-input>
              </div>
            </b-col>
            <el-table :data="queriedData"
                      row-key="id"
                      header-row-class-name="thead-light"
                      @sort-change="sortChange"
                      @selection-change="selectionChange">>
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                v-bind="column"
              >
              </el-table-column>
              <el-table-column width="120px" label="Active" prop="active" sortable align="center">
                <template v-slot="{row}">
                  <badge class="badge-dot mr-4">
                    <i :class="`bg-${row.asset.active? 'success' : 'danger'}`"></i>
                  </badge>
                </template>
              </el-table-column>
              <el-table-column min-width="140px" align="right" label="Actions">
                <div slot-scope="{$index, row}" class="d-flex">
                  <base-button
                    v-b-tooltip.hover title="Select asset"
                    @click.native="handleAssetSelect($index, row)"
                    class="edit btn-link"
                    type="info"
                    size="sm"
                    icon
                  >
                    <i class="text-white ni ni-pin-3"></i>
                  </base-button>
                  <base-button
                    v-b-tooltip.hover title="Edit asset"
                    @click.native="handleAssetEdit($index, row)"
                    class="edit btn-link"
                    type="info"
                    size="sm"
                    icon
                  >
                    <i class="text-white ni ni-ruler-pencil"></i>
                  </base-button>
                  <base-button
                    v-if="row.device"
                    v-b-tooltip.hover title="Unlink device"
                    @click.native="handleDeviceLink($index, row)"
                    class="edit btn-link"
                    type="info"
                    size="sm"
                    icon
                  >
                    <i class="text-white ni ni-lock-circle-open"></i>
                  </base-button>
                  <base-button
                    v-if="row.fixedDriverName"
                    v-b-tooltip.hover title="Unlink driver"
                    @click.native="handleDriverLink($index, row)"
                    class="edit btn-link"
                    type="info"
                    size="sm"
                    icon
                  >
                    <i class="text-white ni ni-lock-circle-open"></i>
                  </base-button>

                </div>
              </el-table-column>

            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
              </p>

            </div>
            <base-pagination
              class="pagination-no-border"
              :current="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
              @change="paginationChanged($event)"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </b-container>
  </div>
</template>

<script>
import {Option, Select, Table, TableColumn} from 'element-ui';
import { BasePagination } from '@/components';
import clientPaginationMixin from './clientPaginationMixin'
import crudApi from "../../crud/crud-api";

export default {
  mixins: [clientPaginationMixin],
  components: {
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  props: {
    props: ['config'],
  },
  data: _ => ({
    propsToSearch: ['assetName', 'asset.registrationNumber', 'device.identifier', 'groupNames', 'configurationGroup.name', 'fixedDriverName'],
    tableColumns: [
      {
        prop: 'assetName',
        label: 'Asset',
        minWidth: 140
      },
      {
        prop: 'asset.registrationNumber',
        label: 'Registration number',
        minWidth: 160
      },
      {
        prop: 'device.identifier',
        label: 'Device identifier',
        minWidth: 140
      },
      {
        prop: 'groupNames',
        label: 'Groups',
        minWidth: 200
      },
      {
        prop: 'configurationGroup.name',
        label: 'Configuration group',
        minWidth: 200
      },
      {
        prop: 'fixedDriverName',
        label: 'Fixed driver',
        minWidth: 160
      },
    ],
    tableData: [],
    selectedRows: [],
  }),
  watch: {
    tableData: function (newValue) {
      if (this.tableData) {
        for (let data of this.tableData) {
          let groupNames = undefined
          if (data.groups) {
            for (let group of data.groups) {
              if (!groupNames) {
                groupNames = group.name
              } else {
                groupNames += ", " + group.name
              }
            }
            if (groupNames) {
              data.groupNames = groupNames
            }
          }

          if (data.asset.fixedDriver && data.driverName) {
            data.fixedDriverName = data.driverName
          }
        }
      }
    }
  },
  computed: {
    loadFleetData() {
      this.getFleetData()

      return true
    }
  },
  methods: {
    getFleetData() {
      crudApi.getOrganisationAssetOverview(this.$store.state.auth.user.organisation_id, true).then(json => this.tableData = json.data ? json.data : json)
    },
    handleAssetEdit(index, row) {
      this.$router.push({name:"entity-edit", params:{entity:row.asset, entityType:"assets"}});
    },
    handleAssetSelect(index, row) {
      this.$router.push({ name: 'asset-detail', params: { type: 'ASSET', entityId: row.asset.id}});
    },
    handleDeviceLink(index, row) {
      this.$router.push({name:"entity-links", params:{model:row.device, entityType:"devices"}});
    },
    handleDriverLink(index, row) {
      this.$router.push({name:"entity-links", params:{model:row.driver, entityType:"drivers"}});
    },
    paginationChanged(page) {
      this.pagination.currentPage = page
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows
    },
    dataChanged() {
      console.log("table dataChanged")
      clientPaginationMixin.data()
      clientPaginationMixin.dataChanged()
    }
  }
}
</script>

<style scoped>
.no-border-card .card-footer{
  border-top: 0;
}
</style>
